import { render, staticRenderFns } from "./SchHome.vue?vue&type=template&id=49c8323b&scoped=true"
import script from "./SchHome.vue?vue&type=script&lang=js"
export * from "./SchHome.vue?vue&type=script&lang=js"
import style0 from "./SchHome.vue?vue&type=style&index=0&id=49c8323b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c8323b",
  null
  
)

export default component.exports